export default __webpack_public_path__ + "static/media/C_02_01_bg.d2bee8ed.mp4";